var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useContext, useEffect, useState, useCallback, } from 'react';
import { get } from 'lodash';
import { Dialog, Paper, createStyles, makeStyles, } from '@material-ui/core';
import DataGrid, { SearchPanel, Column, Scrolling, } from 'devextreme-react/data-grid';
import { LocationAvatar, AccountAvatar, LoadingBounce, } from '@michelin/acid-components';
import { useTranslation } from 'react-i18next';
import { CentralProviderContext } from '../../centralProviderContext/CentralProviderContext';
import { ClosableDialogTitle, ClosableDialogContent } from '../../compositions/ClosableDialog';
import { CentralProviderErrorTypes } from '../../constants/centralProviderErrors';
var useStyles = makeStyles(function () { return createStyles({
    customerFleetList: {
        '& tr.dx-header-row': {
            display: 'none',
        },
    },
}); });
function getAccountData(data) {
    return get(data, 'accounts.0');
}
function getSearchText(accountData) {
    if (!accountData)
        return '';
    return "".concat(accountData.accountNumber, " ").concat(accountData.name, " ").concat(accountData.customer_name, " ").concat(accountData.customer_type, " ").concat(accountData.address.address1, " ").concat(accountData.address.address2, " ").concat(accountData.address.city, " ").concat(accountData.address.state, " ").concat(accountData.address.zip, " ").concat(accountData.address.city, " ").concat(accountData.customer_type);
}
function RenderAccountAvatar(_a) {
    var _b;
    var accountData = _a.accountData, _c = _a.style, style = _c === void 0 ? {} : _c;
    var centralProverContext = useContext(CentralProviderContext);
    if (!accountData)
        return null;
    return (React.createElement(AccountAvatar, { name: accountData.name || accountData.customer_name || '', accountType: accountData.customer_type, address: accountData.address, accountNumbers: {
            parentCompany: accountData.customer_type === 'PC' ? accountData.accountNumber : '',
            homeOffice: accountData.customer_type === 'HO' ? accountData.accountNumber : '',
            billTo: accountData.customer_type === 'BT' ? accountData.accountNumber : '',
            shipTo: accountData.customer_type === 'ST' ? accountData.accountNumber : '',
            mdm: centralProverContext.useMdmId ? (_b = accountData.mdm) === null || _b === void 0 ? void 0 : _b.site_id : undefined,
        }, style: style }));
}
function RenderAccount(_a) {
    var data = _a.data, onClick = _a.onClick;
    var accountData = getAccountData(data);
    return (React.createElement("div", { style: { zoom: 1.1, padding: 4 }, onClick: onClick },
        React.createElement(RenderAccountAvatar, { accountData: accountData, style: onClick ? { cursor: 'pointer' } : {} })));
}
export var LocationSelector = function () {
    var t = useTranslation().t;
    var centralProviderContext = useContext(CentralProviderContext);
    var _a = __read(useState(centralProviderContext.selectedGrant), 2), grantLocation = _a[0], setCurrentLocation = _a[1];
    var _b = __read(useState(false), 2), modalOpen = _b[0], toggleModal = _b[1];
    var _c = __read(useState(false), 2), switching = _c[0], setSwitching = _c[1];
    var classes = useStyles();
    var handleModal = useCallback(function () {
        toggleModal(!modalOpen);
    }, [modalOpen]);
    // select new grant
    var handleConfirmation = function (grant) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (!grant || switching)
                return [2 /*return*/];
            setCurrentLocation(grant);
            setSwitching(true);
            setTimeout(function () {
                // select grant
                centralProviderContext.setCurrentGrant(grant);
                toggleModal(false);
                setTimeout(setSwitching, 200, false);
            }, 1);
            return [2 /*return*/];
        });
    }); };
    // select default grant
    useEffect(function () {
        if (!centralProviderContext.selectedGrant
            && !grantLocation
            && centralProviderContext.centralProfile
            && centralProviderContext.centralProfile.grants) {
            // default select
            var grant = centralProviderContext.selectedGrant || get(centralProviderContext, 'centralProfile.grants.0');
            if (!grant && !['/change-password', '/user-profile-form'].some(function (el) { return (window.location.pathname).includes(el); })) {
                centralProviderContext.setError({ key: CentralProviderErrorTypes.NO_GRANT });
                return;
            }
            setCurrentLocation(grant);
            centralProviderContext.setCurrentGrant(grant);
        }
    }, [centralProviderContext.centralProfile, centralProviderContext.allowGrantLocationSelector, grantLocation]);
    useEffect(function () {
        if (centralProviderContext.selectedGrant && centralProviderContext.selectedGrantLocation) {
            setCurrentLocation(centralProviderContext.selectedGrant);
        }
    }, [centralProviderContext.selectedGrant, centralProviderContext.selectedGrantLocation]);
    if (!centralProviderContext.centralProfile
        || !grantLocation
        || !centralProviderContext.allowGrantLocationSelector || !centralProviderContext.centralProfile.grants) {
        return null;
    }
    var accountType = get(grantLocation, 'accounts.0.customer_type');
    var type = get(grantLocation, 'grant_location_type', '-');
    var name = get(grantLocation, 'location.name', '-');
    var accountNumber = get(grantLocation, 'accounts.0.customer_number', '-');
    var mdmId = get(grantLocation, 'accounts.0.mdm.site_id', undefined);
    var role = get(grantLocation, 'roles.0.name', '-');
    var address;
    if (typeof (get(grantLocation, 'accounts.0.address')) === 'string') {
        address = {
            address1: get(grantLocation, 'accounts.0.customer_addr1'),
            address2: get(grantLocation, 'accounts.0.customer_addr2'),
            city: get(grantLocation, 'accounts.0.customer_city'),
            state: get(grantLocation, 'accounts.0.customer_state'),
            zip: get(grantLocation, 'accounts.0.customer_zip'),
            country: get(grantLocation, 'accounts.0.customer_country'),
        };
    }
    else {
        address = get(grantLocation, 'accounts.0.address');
    }
    var tablaRender = [];
    var index = 0;
    if (!centralProviderContext.centralProfile.grants
        || centralProviderContext.centralProfile.grants.length === 0)
        return null;
    centralProviderContext.centralProfile.grants.forEach(function (g) {
        if (g.accounts && g.accounts[0]) {
            (g.accounts).forEach(function (l) {
                tablaRender.push(__assign(__assign({ index: index }, g), { accounts: [l] }));
                index += 1;
            });
        }
    });
    return (React.createElement(React.Fragment, null,
        React.createElement("div", null,
            React.createElement(LocationAvatar, { variant: "dropdown", name: name, role: role, locationType: type, accountType: t(accountType), accountNumbers: {
                    parentCompany: accountNumber,
                    billTo: accountType === 'BT' ? accountNumber || undefined : undefined,
                    shipTo: accountType === 'ST' ? accountNumber || undefined : undefined,
                    mdm: centralProviderContext.useMdmId ? mdmId : undefined,
                }, address: address, displaySwitchAccount: tablaRender.length > 0, onSwitchAccount: handleModal })),
        React.createElement(Dialog, { onClose: handleModal, "aria-labelledby": "customized-dialog-title", open: modalOpen, fullWidth: true, maxWidth: "md" },
            React.createElement(ClosableDialogTitle, { onClose: !switching ? handleModal : function () { return null; } }, t(!switching ? 'Select a Location' : 'Loaging location data...')),
            React.createElement(ClosableDialogContent, { style: { padding: 0 }, dividers: true }, switching
                ? (React.createElement(React.Fragment, null,
                    React.createElement("div", { style: {
                            zoom: 1.7, margin: '18px auto 0', opacity: 0.4, width: '50%',
                        } },
                        React.createElement(RenderAccount, { data: grantLocation })),
                    React.createElement(LoadingBounce, { style: { height: '70px', zoom: 0.8 } })))
                : (React.createElement(Paper, { className: classes.customerFleetList },
                    React.createElement(DataGrid, { dataSource: tablaRender, rowAlternationEnabled: true, style: { height: '60vh' } },
                        React.createElement(Scrolling, { mode: "virtual" }),
                        React.createElement(SearchPanel, { visible: true, highlightSearchText: false, placeholder: t('Search...') }),
                        React.createElement(Column, { cellRender: function (_a) {
                                var row = _a.row;
                                return (React.createElement(RenderAccount, { data: row.data, onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                                        return __generator(this, function (_a) {
                                            handleConfirmation(row.data);
                                            return [2 /*return*/];
                                        });
                                    }); } }));
                            }, calculateCellValue: function (data) { return getSearchText(getAccountData(data)); }, allowSearch: true }))))))));
};
//# sourceMappingURL=LocationSelector.js.map